var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('router-view'),_c('div',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.getCurrentYear)+" | hopnami")]),_c('stream-player'),_c('app-ads')],1)}
var staticRenderFns = []

export { render, staticRenderFns }